import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { TOAST_VARIANTS } from "../constants";
import { getRem, typographyBody1 } from "./../../core";
var ToastBody = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['variant', 'withMultipleActions'].includes(prop);
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  background-color: ", ";\n  border-bottom-right-radius: ", ";\n  border-color: ", ";\n  border-style: solid;\n  border-top-right-radius: ", ";\n  border-width: ", " ", " ", " 0;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: ", ";\n  min-width: 0;\n  width: 100%;\n"])), function (_ref) {
  var theme = _ref.theme;
  return typographyBody1(theme);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.color.additional.light.value;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.size.borderRadius.large.value;
}, function (_ref4) {
  var theme = _ref4.theme,
      variant = _ref4.variant;
  return theme.color.system[variant][500].value;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.size.borderRadius.large.value;
}, getRem('2px'), getRem('2px'), getRem('2px'), function (_ref6) {
  var withMultipleActions = _ref6.withMultipleActions;
  return withMultipleActions ? 'column' : 'row';
});
ToastBody.propTypes = {
  /** Any content inserted between component tags */
  children: PropTypes.node.isRequired,

  /** Changes style depending on variant. */
  variant: PropTypes.oneOf(Object.values(TOAST_VARIANTS)),

  /** If true, changes body structure to column */
  withMultipleActions: PropTypes.bool
};
ToastBody.defaultProps = {
  variant: TOAST_VARIANTS.NEUTRAL,
  withMultipleActions: false
};
export { ToastBody };